/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkillLink
 */
export interface SkillLink {
    /**
     * 
     * @type {number}
     * @memberof SkillLink
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SkillLink
     */
    employeeId?: number;
    /**
     * 
     * @type {number}
     * @memberof SkillLink
     */
    skillLevelId?: number;
    /**
     * 
     * @type {Date}
     * @memberof SkillLink
     */
    lastUpdated?: Date;
}

/**
 * Check if a given object implements the SkillLink interface.
 */
export function instanceOfSkillLink(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SkillLinkFromJSON(json: any): SkillLink {
    return SkillLinkFromJSONTyped(json, false);
}

export function SkillLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'employeeId': !exists(json, 'employeeId') ? undefined : json['employeeId'],
        'skillLevelId': !exists(json, 'skillLevelId') ? undefined : json['skillLevelId'],
        'lastUpdated': !exists(json, 'lastUpdated') ? undefined : (new Date(json['lastUpdated'])),
    };
}

export function SkillLinkToJSON(value?: SkillLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'employeeId': value.employeeId,
        'skillLevelId': value.skillLevelId,
        'lastUpdated': value.lastUpdated === undefined ? undefined : (value.lastUpdated.toISOString()),
    };
}

